import {
  ArrowDownGreenIcon,
  ArrowRightWhiteIcon,
  ListGreenIcon,
  ListWhiteIcon,
} from "assets/icon";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
function DashboardItem({
  text,
  icon,
  iconActive,
  iconRight,
  iconRightActive,
  url,
  isActive,
  isDropdown = false,
  dataDropDown = [],
}) {
  const [listIcon, setListIcon] = useState(<ListWhiteIcon />);
  const [arrowIcon, setArrowIcon] = useState(<ArrowRightWhiteIcon />);

  const onClickDropDown = () => {
    var dropdown = document.getElementsByClassName("drop");
    dropdown[0].classList.toggle("active");
    var dropdownContent = dropdown[0].nextElementSibling;
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
      setListIcon(<ListWhiteIcon />);
      setArrowIcon(<ArrowRightWhiteIcon />);
    } else {
      dropdownContent.style.display = "block";
      setListIcon(<ListGreenIcon />);
      setArrowIcon(<ArrowDownGreenIcon />);
    }
  };
  useEffect(() => {
    if (isDropdown && isActive) {
      setListIcon(<ListGreenIcon />);
      setArrowIcon(<ArrowDownGreenIcon />);
    }
  }, []);

  return (
    <>
      {isDropdown ? (
        <>
          <button
            onClick={onClickDropDown}
            className={`dashboard-item drop ${isActive ? "active" : ""}`}
            style={{ marginBottom: "0px" }}
          >
            <div className="dashboard-item__header">
              <span className="icon-left">{listIcon}</span>
              <span className="dashboard-item__text">{text}</span>
              <span className="icon-right">{arrowIcon}</span>
            </div>
          </button>
          <div
            className="dropdown-container"
            style={{ display: `${isActive ? "block" : "none"}` }}
          >
            {dataDropDown &&
              dataDropDown.map((item, index) => {
                return (
                  <Link
                    key={`dashboard-${index}`}
                    style={{ display: "flex" }}
                    to={item.url}
                    className={`dashboard-item ${item.isActive && "active"}`}
                  >
                    <div className="spacing-icon" />
                    {item.name}
                    {item.isActive && <span className="dot-active" />}
                  </Link>
                );
              })}
          </div>
        </>
      ) : (
        <Link to={url} className={`dashboard-item ${isActive ? "active" : ""}`}>
          <span className="icon-left"> {isActive ? iconActive : icon}</span>
          <span className="dashboard-item__text">{text}</span>
          <span className="icon-right">
            {isActive ? iconRightActive : iconRight}
          </span>
        </Link>
      )}
    </>
  );
}

export default DashboardItem;
